import api from '@/api'

export default {
  namespaced: true,
  state: {
    items: [],
    fetching: false
  },
  actions: {
    async fetchColors ({ state, commit, getters }) {
      commit('fetching')

      const colors = await api.netshoes.getColors()

      commit('setFetchData', colors)
    }
  },
  getters: {
    getColors: state => () => state.items
  },
  mutations: {
    setFetchData (state, items) {
      state.items = items
      state.fetching = false
    },
    fetching (state) {
      state.fetching = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/colors.js